type Message = {
    action: string
    params?: any
}

export const sendMessageToParentScript = (message: Message) => {
    window.parent.postMessage(message, '*') // TODO: Target origin
}
